import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://pafhub.com';
const OG_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/ef4bc1f2-6cd9-494d-9b16-9cd0314ad1a5/images/05b929a181a0cbb85708f633cbcd5da66236100ec498fa1a8a4b76acae04f377.png';

export default function SEO({ title, description, path = '', keywords }) {
  const fullTitle = title ? `${title} | PAFHub` : 'Public Access File Management | H-1B PAF Compliance Software';
  const desc = description || 'Manage H-1B, H-1B1, and E-3 Public Access Files effortlessly. Stay DOL-compliant with automated PAF generation, document storage, and audit-ready recordkeeping.';
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
